/**
 * Listes d'attente du membre (GET client/waitlist), « Voir tous mes cours » v2.
 */
import { toDate } from './format';

/** Entrée de GET client/waitlist (= WaitlistHistoryItem.tsx WaitlistEntry). */
export interface WaitlistEntry {
  Id: number;
  ClassId: number;
  ClassDate: string;
  StartTime: string;
  StartDateTime: string;
  SiteId?: number;
  ClassSchedule?: {
    StartTime: string;
    ClassDescription?: { Name?: string };
    Staff?: { Id: number };
    Location?: { Id: number };
  };
}

/** = WaitlistHistoryItem.tsx getDateTime() : ClassDate (jour) + ClassSchedule.StartTime (heure). */
export function waitlistStart(entry: WaitlistEntry): Date | null {
  if (!entry.ClassDate || !entry.ClassSchedule?.StartTime) return null;
  const datePart = entry.ClassDate.split('T')[0];
  const timePart = entry.ClassSchedule.StartTime.split('T')[1];
  return toDate(`${datePart}T${timePart}`);
}
